export const AtaskKoregavimasEnum = [
  'DUOMENU_ATNAUJINIMAS',
  'ATASKAITOS_PATEIKIMAS',
  'DUOMENU_TVARKYMAS',
  'AUTO_DUOMENU_ATNAUJINIMAS'
] as const;

export type AtaskKoregavimasEnumType = typeof AtaskKoregavimasEnum[number];
